import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: '$futureOrderingEnableCatering',
  initialState: false,
  reducers: {
    setFutureOrderingEnableCatering(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setFutureOrderingEnableCatering } = slice.actions;
export default slice.reducer;
